import React from 'react';



type Props  =  {
  className?: string;
}
export const EmptyCaseStarVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '100%' height = '100%'  viewBox = '0 0 88 88' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M34 39L54 58M34 58L41.2727 51.0909M54 39L44 48.5' />
      <path stroke = 'currentColor' strokeWidth = '2' strokeMiterlimit = '10' d = 'M60.9907 51.1513L69.508 78.0093L64.2815 82L46.0158 68.0528C45.4356 67.6093 44.7367 67.3704 44.0194 67.3704C43.302 67.3704 42.6031 67.6093 42.0229 68.0528L23.7572 82L18.5307 78.0093L25.4994 55.4377C25.7213 54.7208 25.7214 53.9485 25.4998 53.2315C25.2781 52.5146 24.8461 51.8898 24.2657 51.447L6 37.4971L7.99769 31.0376H30.5737C31.291 31.0379 31.9901 30.7995 32.5705 30.3565C33.151 29.9135 33.5832 29.2886 33.8051 28.5716L40.7738 6H47.2262L54.1949 28.5716C54.4168 29.2886 54.8489 29.9135 55.4294 30.3565C56.0099 30.7995 56.709 31.0379 57.4263 31.0376H80.0049L82 37.4971L69.5312 47.0114' />
    </svg>
  );
};
